export enum Permission {
  ItemPriceManagementView = 'item_price_management.view',
  ItemPriceManagementModify = 'item_price_management.modify',
  ItemPriceManagementDeleteChangeRequest = 'item_price_management.delete_change_request',
  ItemPriceManagementReview = 'item_price_management.review',
  ItemPriceManagementPartnerApprove = 'item_price_management.partner_approve',
  ItemPriceManagementDebug = 'item_price_management.debug',
}
